export default __webpack_public_path__ + "static/media/Slide31.b8bb719a.JPG";